@if (subscription) {
  <div class="subscription-item">
    <div
      [style]="getBackgroundStyleObject(subscription, 'cover_url')"
      (click)="subscribeClick()"
      [class.interactive]="interactive"
      class="cover"
    >
      @if (hasPrice) {
        <div class="price">
          {{ subscription.price !== 'free' ? '$' : '' }}{{ subscription.price }}
        </div>
      }
      @if (hasDiscount) {
        <div class="discount">{{ subscription.discount }}% off</div>
      }
    </div>
    <div class="title">{{ subscription.title }}</div>
    <div class="description">
      <div class="features-block">
        @for (feature of subscription.features; track feature) {
          <div class="feature-item">{{ feature }}</div>
        }
      </div>
    </div>
  </div>
}
